import { oz } from '@weft/utils';
import { FixedProductVariantSchema } from '../../product-variant';
import { ProductSchema } from '../product-schema';

export const FixedProductSchema = ProductSchema.extend({
  variants: oz.array(FixedProductVariantSchema).min(1),
});

export type FixedProduct = oz.infer<typeof FixedProductSchema>;